import React from 'react'
import { Link } from 'react-router-dom'
import { Heart, Home, Users, Phone, ArrowRight, CheckCircle, Shield, Clock, Award } from 'lucide-react'

const HomePage = () => {
  const services = [
    {
      icon: Home,
      title: 'Homemaker Services',
      description: 'Light housekeeping, laundry, meal preparation, and household organization to maintain a comfortable living environment.',
    },
    {
      icon: Heart,
      title: 'Personal Care Provider',
      description: 'Compassionate assistance with bathing, grooming, dressing, and mobility support for daily living.',
    },
  ]

  const values = [
    {
      icon: Shield,
      title: 'Trustworthy',
      description: 'Reliable care you can depend on',
    },
    {
      icon: Heart,
      title: 'Compassionate',
      description: 'Caring support with dignity',
    },
    {
      icon: Clock,
      title: 'Flexible',
      description: 'Services tailored to your needs',
    },
    {
      icon: Award,
      title: 'Professional',
      description: 'Trained and experienced caregivers',
    },
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/Home.jsx" data-component-line="1:1" data-component-id="client/src/pages/Home.jsx:1:1">
      <section className="relative bg-gradient-to-br from-auburn-50 via-white to-stone-50 py-20 lg:py-32" data-component-path="client/src/pages/Home.jsx" data-component-line="2:2" data-component-id="client/src/pages/Home.jsx:2:2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="3:3" data-component-id="client/src/pages/Home.jsx:3:3">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/Home.jsx" data-component-line="4:4" data-component-id="client/src/pages/Home.jsx:4:4">
            <div className="flex flex-col gap-8" data-component-path="client/src/pages/Home.jsx" data-component-line="5:5" data-component-id="client/src/pages/Home.jsx:5:5">
              <div className="flex flex-col gap-4" data-component-path="client/src/pages/Home.jsx" data-component-line="6:6" data-component-id="client/src/pages/Home.jsx:6:6">
                <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight" data-component-path="client/src/pages/Home.jsx" data-component-line="7:7" data-component-id="client/src/pages/Home.jsx:7:7">
                  Compassionate In-Home Support You Can Trust
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed" data-component-path="client/src/pages/Home.jsx" data-component-line="10:10" data-component-id="client/src/pages/Home.jsx:10:10">
                  Providing dependable Homemaker and Personal Care services that promote safety, dignity, and independence.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-component-path="client/src/pages/Home.jsx" data-component-line="14:14" data-component-id="client/src/pages/Home.jsx:14:14">
                <Link
                  to="/contact"
                  className="flex items-center justify-center gap-2 h-14 px-8 bg-auburn-700 text-white rounded-lg hover:bg-auburn-800 transition-all duration-200 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-auburn-300/50 text-lg font-semibold"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="15:15"
                  data-component-id="client/src/pages/Home.jsx:15:15"
                >
                  Request Services
                  <ArrowRight className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="20:20" data-component-id="client/src/pages/Home.jsx:20:20" />
                </Link>
                <a
                  href="tel:7205380225"
                  className="flex items-center justify-center gap-2 h-14 px-8 bg-white text-auburn-700 border-2 border-auburn-700 rounded-lg hover:bg-auburn-50 transition-all duration-200 shadow-md hover:shadow-lg focus:ring-4 focus:ring-auburn-300/50 text-lg font-semibold"
                  data-component-path="client/src/pages/Home.jsx"
                  data-component-line="22:22"
                  data-component-id="client/src/pages/Home.jsx:22:22"
                >
                  <Phone className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="27:27" data-component-id="client/src/pages/Home.jsx:27:27" />
                  Contact Us
                </a>
              </div>
            </div>
            <div className="relative" data-component-path="client/src/pages/Home.jsx" data-component-line="32:32" data-component-id="client/src/pages/Home.jsx:32:32">
              <img
                src="https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="White elderly man receiving compassionate care from caregiver"
                className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/7551671/pexels-photo-7551671.jpeg?auto=compress&cs=tinysrgb&w=1200'
                }}
                data-component-path="client/src/pages/Home.jsx"
                data-component-line="33:33"
                data-component-id="client/src/pages/Home.jsx:33:33"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border-4 border-auburn-100" data-component-path="client/src/pages/Home.jsx" data-component-line="43:43" data-component-id="client/src/pages/Home.jsx:43:43">
                <div className="flex items-center gap-3" data-component-path="client/src/pages/Home.jsx" data-component-line="44:44" data-component-id="client/src/pages/Home.jsx:44:44">
                  <div className="w-12 h-12 bg-auburn-100 rounded-full flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="45:45" data-component-id="client/src/pages/Home.jsx:45:45">
                    <Heart className="w-6 h-6 text-auburn-700" data-component-path="client/src/pages/Home.jsx" data-component-line="46:46" data-component-id="client/src/pages/Home.jsx:46:46" />
                  </div>
                  <div data-component-path="client/src/pages/Home.jsx" data-component-line="48:48" data-component-id="client/src/pages/Home.jsx:48:48">
                    <p className="text-2xl font-bold text-gray-900" data-component-path="client/src/pages/Home.jsx" data-component-line="49:49" data-component-id="client/src/pages/Home.jsx:49:49">Aurora, CO</p>
                    <p className="text-sm text-gray-600" data-component-path="client/src/pages/Home.jsx" data-component-line="50:50" data-component-id="client/src/pages/Home.jsx:50:50">Serving Denver Metro</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-component-path="client/src/pages/Home.jsx" data-component-line="60:60" data-component-id="client/src/pages/Home.jsx:60:60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="61:61" data-component-id="client/src/pages/Home.jsx:61:61">
          <div className="text-center mb-16" data-component-path="client/src/pages/Home.jsx" data-component-line="62:62" data-component-id="client/src/pages/Home.jsx:62:62">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="63:63" data-component-id="client/src/pages/Home.jsx:63:63">Why Choose Us</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Home.jsx" data-component-line="64:64" data-component-id="client/src/pages/Home.jsx:64:64">
              We're committed to providing exceptional care that makes a difference in people's lives
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-component-path="client/src/pages/Home.jsx" data-component-line="68:68" data-component-id="client/src/pages/Home.jsx:68:68">
            {values.map((value, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center gap-4 p-6 rounded-xl hover:bg-auburn-50 transition-colors duration-200"
                data-component-path="client/src/pages/Home.jsx"
                data-component-line="69:69"
                data-component-id="client/src/pages/Home.jsx:69:69"
              >
                <div className="w-16 h-16 bg-auburn-100 rounded-full flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="74:74" data-component-id="client/src/pages/Home.jsx:74:74">
                  <value.icon className="w-8 h-8 text-auburn-700" data-component-path="client/src/pages/Home.jsx" data-component-line="75:75" data-component-id="client/src/pages/Home.jsx:75:75" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-component-path="client/src/pages/Home.jsx" data-component-line="77:77" data-component-id="client/src/pages/Home.jsx:77:77">{value.title}</h3>
                <p className="text-gray-600" data-component-path="client/src/pages/Home.jsx" data-component-line="78:78" data-component-id="client/src/pages/Home.jsx:78:78">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-stone-50" data-component-path="client/src/pages/Home.jsx" data-component-line="86:86" data-component-id="client/src/pages/Home.jsx:86:86">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Home.jsx" data-component-line="87:87" data-component-id="client/src/pages/Home.jsx:87:87">
          <div className="text-center mb-16" data-component-path="client/src/pages/Home.jsx" data-component-line="88:88" data-component-id="client/src/pages/Home.jsx:88:88">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Home.jsx" data-component-line="89:89" data-component-id="client/src/pages/Home.jsx:89:89">Our Services</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Home.jsx" data-component-line="90:90" data-component-id="client/src/pages/Home.jsx:90:90">
              Comprehensive support services designed to help you live independently
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8" data-component-path="client/src/pages/Home.jsx" data-component-line="94:94" data-component-id="client/src/pages/Home.jsx:94:94">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-200 border border-gray-100"
                data-component-path="client/src/pages/Home.jsx"
                data-component-line="95:95"
                data-component-id="client/src/pages/Home.jsx:95:95"
              >
                <div className="flex items-start gap-4" data-component-path="client/src/pages/Home.jsx" data-component-line="100:100" data-component-id="client/src/pages/Home.jsx:100:100">
                  <div className="w-12 h-12 bg-auburn-100 rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="101:101" data-component-id="client/src/pages/Home.jsx:101:101">
                    <service.icon className="w-6 h-6 text-auburn-700" data-component-path="client/src/pages/Home.jsx" data-component-line="102:102" data-component-id="client/src/pages/Home.jsx:102:102" />
                  </div>
                  <div className="flex-1" data-component-path="client/src/pages/Home.jsx" data-component-line="104:104" data-component-id="client/src/pages/Home.jsx:104:104">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3" data-component-path="client/src/pages/Home.jsx" data-component-line="105:105" data-component-id="client/src/pages/Home.jsx:105:105">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed" data-component-path="client/src/pages/Home.jsx" data-component-line="106:106" data-component-id="client/src/pages/Home.jsx:106:106">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12" data-component-path="client/src/pages/Home.jsx" data-component-line="112:112" data-component-id="client/src/pages/Home.jsx:112:112">
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 bg-auburn-700 text-white rounded-lg hover:bg-auburn-800 transition-all duration-200 shadow-md hover:shadow-lg focus:ring-4 focus:ring-auburn-300/50"
              data-component-path="client/src/pages/Home.jsx"
              data-component-line="113:113"
              data-component-id="client/src/pages/Home.jsx:113:113"
            >
              View All Services
              <ArrowRight className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="118:118" data-component-id="client/src/pages/Home.jsx:118:118" />
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-auburn-700" data-component-path="client/src/pages/Home.jsx" data-component-line="125:125" data-component-id="client/src/pages/Home.jsx:125:125">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/Home.jsx" data-component-line="126:126" data-component-id="client/src/pages/Home.jsx:126:126">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-component-path="client/src/pages/Home.jsx" data-component-line="127:127" data-component-id="client/src/pages/Home.jsx:127:127">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-auburn-50 mb-8" data-component-path="client/src/pages/Home.jsx" data-component-line="130:130" data-component-id="client/src/pages/Home.jsx:130:130">
            Contact us today to learn more about our services and how we can support you or your loved ones.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-component-path="client/src/pages/Home.jsx" data-component-line="133:133" data-component-id="client/src/pages/Home.jsx:133:133">
            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 h-14 px-8 bg-white text-auburn-700 rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-white/50 text-lg font-semibold"
              data-component-path="client/src/pages/Home.jsx"
              data-component-line="134:134"
              data-component-id="client/src/pages/Home.jsx:134:134"
            >
              Request Services
            </Link>
            <a
              href="tel:7205380225"
              className="flex items-center justify-center gap-2 h-14 px-8 bg-auburn-800 text-white rounded-lg hover:bg-auburn-900 transition-all duration-200 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-white/50 text-lg font-semibold"
              data-component-path="client/src/pages/Home.jsx"
              data-component-line="140:140"
              data-component-id="client/src/pages/Home.jsx:140:140"
            >
              <Phone className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Home.jsx" data-component-line="145:145" data-component-id="client/src/pages/Home.jsx:145:145" />
              720.538.0225
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default HomePage